// DOM id on the association-settings <form>; lets the focus-on-error effect scope
// its invalid-field lookup to this form (see FocusFirstInvalidField).
export const UPDATE_COMPANY_FORM_ID = 'update-company-form';
